import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const routeLabels: Record<string, string> = {
  "": "Dashboard",
  devices: "Devices",
  firmware: "Files",
  tasks: "Tasks",
  groups: "Device groups",
  settings: "Company",
  "group-keys": "Group Keys",
  "api-credentials": "API Credentials",
  usage: "Usage",
  users: "Users",
  upload: "Upload",
  create: "Create",
  profile: "Profile",
  notifications: "Notifications",
  preferences: "Preferences",
  "audit-log": "Audit Log",
  help: "Help & Guides",
  admin: "Admin",
  companies: "Companies",
  dashboard: "Dashboard",
  "sign-in": "Sign In",
  register: "Register",
  "forgot-password": "Forgot Password",
  "reset-password": "Reset Password",
};

function formatLabel(segment: string): string {
  return routeLabels[segment] ?? segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " ");
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  const segments = pathname.split("/").filter(Boolean);
  const crumbs = segments.map((seg, i) => {
    const path = "/" + segments.slice(0, i + 1).join("/");
    const label = formatLabel(seg);
    const isLast = i === segments.length - 1;
    return { label, path, isLast };
  });

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-xs text-gray-400 dark:text-riot-navy-400">
      <Link to="/" className="hover:text-gray-600 dark:hover:text-riot-navy-200">
        Dashboard
      </Link>
      {crumbs.map((crumb) => (
        <span key={crumb.path} className="flex items-center gap-1">
          <ChevronRight size={12} />
          {crumb.isLast ? (
            <span className="font-medium text-gray-700 dark:text-riot-navy-200">{crumb.label}</span>
          ) : (
            <Link to={crumb.path} className="hover:text-gray-600 dark:hover:text-riot-navy-200">
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
}
